import { b2cVersion } from '../utils/consts.ts';
import { useB2CModeStore } from '../services/store';

export const useIsBlockchainVersion = () => {
  const b2cMode = useB2CModeStore(({ mode }) => mode);
  return b2cVersion && b2cMode === 'blockchain';
};
